export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
export const SET_DASHBOARD_LOADING = 'SET_DASHBOARD_LOADING';
export const SET_ANIO_ACTIVO = 'SET_ANIO_ACTIVO';
export const SET_SUCURSAL_ACTIVA = 'SET_SUCURSAL_ACTIVA';
export const SET_MES_ACTIVO = 'SET_MES_ACTIVO';
export const SET_SECTOR_ACTIVO = 'SET_SECTOR_ACTIVO';
export const SET_METRICA_ACTIVA = 'SET_METRICA_ACTIVA';
export const SET_PRODUCTOS_ACTIVOS = 'SET_PRODUCTOS_ACTIVOS';
export const SET_PRODUCTOS_DISPONIBLES = 'SET_PRODUCTOS_DISPONIBLES';
export const SET_VER_POR_ACTIVO = 'SET_VER_POR_ACTIVO';
export const SET_SEMANA_ACTIVA = 'SET_SEMANA_ACTIVA';
export const SET_FECHA_DESDE = 'SET_FECHA_DESDE';
export const SET_FECHA_HASTA = 'SET_FECHA_HASTA';

const initialState = {
    cachePorAnio: {},
    loading: false,
    anioActivo: new Date().getFullYear().toString(),
    sucursalActiva: '',
    mesActivo: '',
    sectorActivo: '',
    metricaActiva: 'monto', // 'monto' o 'unidades'
    productosActivos: [], // Array de IDs de productos seleccionados
    productosDisponibles: [], // Lista de productos para el combo
    verPorActivo: 'mes',
    semanaActiva: '',
    fechaDesde: '',
    fechaHasta: ''
};

export default function ventasDashboardReducer(state = initialState, action) {
    switch(action.type) {
        case SET_DASHBOARD_LOADING:
            return { ...state, loading: action.payload };
        case SET_ANIO_ACTIVO:
            return { ...state, anioActivo: action.payload };
        case SET_SUCURSAL_ACTIVA:
            return { ...state, sucursalActiva: action.payload };
        case SET_MES_ACTIVO:
            return { ...state, mesActivo: action.payload };
        case SET_SECTOR_ACTIVO:
            return { ...state, sectorActivo: action.payload };
        case SET_METRICA_ACTIVA:
            return { ...state, metricaActiva: action.payload };
        case SET_PRODUCTOS_ACTIVOS:
            return { ...state, productosActivos: action.payload };
        case SET_PRODUCTOS_DISPONIBLES:
            return { ...state, productosDisponibles: action.payload };
        case SET_VER_POR_ACTIVO:
            return { ...state, verPorActivo: action.payload };
        case SET_SEMANA_ACTIVA:
            return { ...state, semanaActiva: action.payload };
        case SET_FECHA_DESDE:
            return { ...state, fechaDesde: action.payload };
        case SET_FECHA_HASTA:
            return { ...state, fechaHasta: action.payload };
        case SET_DASHBOARD_DATA:
            const { cacheKey, data } = action.payload;
            return {
                ...state,
                cachePorAnio: {
                    ...state.cachePorAnio,
                    [cacheKey]: data
                },
                loading: false
            };
        default:
            return state;
    }
}
